import styled from "@emotion/styled";
import type { TooltipProps } from "@mui/material";
import { IconButton, Tooltip, tooltipClasses } from "@mui/material";
import React from "react";

import { fontRoboto } from "shared/lib/styles";

export const CloseButton = styled(IconButton)`
  flex: none;

  margin-inline-start: 18px;
  padding: 0;
`;

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))`
  & .${tooltipClasses.tooltip} {
    display: flex;
    flex-flow: row nowrap;
    justify-content: end;
    align-items: flex-start;

    inline-size: max-content;
    max-inline-size: 325px;
    padding: 16px;

    color: #ffffff;
    font-weight: 400;
    font-size: 16px;
    font-family: ${fontRoboto};
    line-height: 22px;

    border-radius: 0;

    background: rgba(0, 18, 70, 0.9);

    cursor: pointer;

    user-select: none;
  }

  & .${tooltipClasses.arrow} {
    color: rgba(0, 18, 70, 0.9);
    font-size: 25px;
  }
`;
